(() => {
  'use strict';

  // This file used to force customers to /checkout if a cart submit looked slow.
  // That is risky in Facebook/Instagram in-app browsers because it can create fragile
  // checkout sessions. We now leave Shopify's native cart form submission untouched.

  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.setAttribute('data-salty-native-checkout', 'true');
  });
})();
